import css from 'styled-jsx/css';

const ImageStyles = css`
  img {
    width: 100%;
  }
`;
export default ImageStyles;
